export default __webpack_public_path__ + "static/media/feat_obts.ae8f80ba.jpg";